module.exports = __webpack_public_path__ + "img/logo-tl-dark.93461dab.svg";